// import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';


// @Directive({
//   // tslint:disable-next-line: directive-selector
//   selector: 'input[upperCaseText]',
// })
// export class upperCaseDirective implements OnInit {


//   constructor(
//     private _element: ElementRef,
//     private renderer: Renderer2,
//   ) {
//   }

//   ngOnInit() { }

//   @HostListener('input', ['$event']) onModelChange(event) {
//     let initialValue = this._element.nativeElement.value;
//     this._element.nativeElement.value = initialValue.toUpperCase();
//   }

// }

import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input[upperCaseText]',
})
export class UpperCaseDirective implements OnInit {
  constructor(
    private _element: ElementRef,
    private renderer: Renderer2,
  ) { }

  ngOnInit() { }

  @HostListener('input', ['$event']) onModelChange(event: KeyboardEvent) {
    let initialValue = this._element.nativeElement.value;
    this._element.nativeElement.value = initialValue.replace(/\s+/g, ' ').toUpperCase();
  }
}
